import { AccountRoleAndPrivilegesWebComponent } from './component/AccountRoleAndPrivilegesWebComponent';
import { WEB_COMPONENT_ACCOUNT_ROLE_AND_PRIVILEGES } from '../../../webcomponents.constants';

export { AccountRoleAndPrivilegesWebComponent };

window.customElements.define(WEB_COMPONENT_ACCOUNT_ROLE_AND_PRIVILEGES, AccountRoleAndPrivilegesWebComponent);
